export default "__VITE_ASSET__8b799932__"